import {
  I2cIcon,
  I2cRadioButton,
  I2cRadioGroup,
  I2cTooltip,
  I2cInput,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import  { validationSchemaAdditionalNetworkServices } from "./validationSchema";
const addtoCartOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "Other", value: "other" },
]; 

const AdditionalNetworkServices = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaAdditionalNetworkServices),
    mode: "all",
    reValidateMode: "all",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin: "no",
      cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other: "",
      cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin: "no",
      cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other: "",
    },
  });

  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin",
    "cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other",
    "cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin",
    "cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other",
  ];

  // Handle value changes and update parent state
  const handleValueChanges = React.useCallback(() => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      2: {
        ...addFormData["2"],
        "2_5": { ...values },
      },
    });
  }, [methods, setAddFormData, addFormData]);

  // Load existing form data
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        const value = formDataJson[2]?.["2_5"]?.[field];
        if (value !== undefined && value !== null) {
          methods.setValue(field, value);
        }
      });
      methods.trigger();
      handleValueChanges();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching]);

  // Trigger validation when component mounts
  useEffect(() => {
    methods.trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Update form validation state when errors change
  useEffect(() => {
    const errorsLength = Object.keys(errors)?.length;
    if (errorsLength === 0) {
      setFormValidStates("2_5", true);
    } else {
      setFormValidStates("2_5", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  // Handle radio button change
  const handleRadioChange = (fieldName, value) => {
    methods.setValue(fieldName, value);
    
    // Clear "other" field when not selecting "other"
    if (value !== "other") {
      if (fieldName === "cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin") {
        methods.setValue("cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other", "");
      } else if (fieldName === "cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin") {
        methods.setValue("cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other", "");
      }
    }
    
    methods.trigger();
    handleValueChanges();
  };

  // Handle input change for "other" fields
  const handleInputChange = (field, value) => {
    methods.setValue(field, value, { shouldValidate: true });
    handleValueChanges();
  };

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md">
          <div i2c-grid="12">
            <div className="section-space">
              <span slot="label" className="organize-tooltip mb-16">
                <div className="sub-heading">Tap To Add Card (TTAC)</div>
                <I2cTooltip
                  content="Tap to Add Card is a secure feature that instantly adds debit/credit cards to digital wallets by holding the physical card against the phone. It replaces manual entry or camera scanning, enabling faster provisioning and, in some contexts, faster payments."
                  placement="right-start"
                >
                  <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
                </I2cTooltip>
              </span>
              <Controller
                name="cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cRadioGroup
                      label="Would you like to enable Tap To Add Card service on your BIN?"
                      value={field.value}
                      onI2cChange={(e) => {
                        const value = e.target.value;
                        handleRadioChange("cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin", value);
                      }}
                    >
                      {addtoCartOptions.map((option) => (
                        <I2cRadioButton key={option.value} value={option.value}>
                          {option.label}
                        </I2cRadioButton>
                      ))}
                    </I2cRadioGroup>
                    {errors.cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin && (
                      <ErrorMessage message={errors.cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin.message} />
                    )}
                  </>
                )}
              />
              
              {methods.watch("cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin") === "other" && (
                <div i2c-grid="grid 4@md" className="mt-16">
                  <div className="single-field-wrapper">
                    <Controller
                      name="cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other"
                      control={control}
                      render={({ field }) => (
                        <>
                          <I2cInput
                            {...field}
                            label="Enter Details"
                            placeholder="Enter Details"
                            size="large"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              handleInputChange("cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other", value);
                            }}
                            invalid={errors.cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other ? true : false}
                          />
                          {errors.cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other && (
                            <ErrorMessage message={errors.cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other.message} />
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
            
            <div>
              <span slot="label" className="organize-tooltip mb-16">
                <div className="sub-heading">Click To Pay</div>
                <I2cTooltip
                  content="Click to Pay is a secure, standardized online checkout service backed by major card networks (Visa, Mastercard, Discover) that eliminates the need to enter 16-digit card numbers, passwords, or fill out long forms. It uses tokenization and biometric security to enable fast, 'one-click' purchases across participating merchants."
                  placement="right-start"
                >
                  <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
                </I2cTooltip>
              </span>
              <Controller
                name="cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cRadioGroup
                      label="Would you like to enable Click to Pay service on your BIN?"
                      value={field.value}
                      onI2cChange={(e) => {
                        const value = e.target.value;
                        handleRadioChange("cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin", value);
                      }}
                    >
                      {addtoCartOptions.map((option) => (
                        <I2cRadioButton key={option.value} value={option.value}>
                          {option.label}
                        </I2cRadioButton>
                      ))}
                    </I2cRadioGroup>
                    {errors.cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin && (
                      <ErrorMessage message={errors.cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin.message} />
                    )}
                  </>
                )}
              />
              
              {methods.watch("cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin") === "other" && (
                <div i2c-grid="grid 4@md" className="mt-16">
                  <div className="single-field-wrapper">
                    <Controller
                      name="cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other"
                      control={control}
                      render={({ field }) => (
                        <>
                          <I2cInput
                            {...field}
                            label="Enter Details"
                            placeholder="Enter Details"
                            size="large"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              handleInputChange("cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other", value);
                            }}
                            invalid={errors.cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other ? true : false}
                          />
                          {errors.cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other && (
                            <ErrorMessage message={errors.cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other.message} />
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdditionalNetworkServices;
